var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "in",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-linkedin-in",
    "data-name": "Icon awesome-linkedin-in",
    d: "M4.535,20.259H.335V6.734h4.2Zm-2.1-15.37A2.444,2.444,0,1,1,4.865,2.433,2.453,2.453,0,0,1,2.432,4.889Zm17.822,15.37H16.063V13.675c0-1.569-.032-3.581-2.184-3.581-2.184,0-2.518,1.7-2.518,3.468v6.7h-4.2V6.734h4.028V8.579h.059a4.413,4.413,0,0,1,3.974-2.184c4.251,0,5.032,2.8,5.032,6.435v7.43Z",
    transform: "translate(1.871 1.87)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.321a7a390f364b337c9a80ba10a2f623.svg";
export { ForwardRef as ReactComponent };